import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import srLocale from 'date-fns/locale/sr-Latn';

const useStyles = makeStyles((theme) => ({
	datePicker: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2)
	}
}));

const MuiDatePicker = (props) => {
    const { name, value, onChange, label, placeholder, readOnly, disabled } = props;
    const { datePicker } = useStyles();

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={srLocale}>
            <KeyboardDateTimePicker
                disabled={disabled}
                name={name}
                label={label}
                placeholder={placeholder}
                className={datePicker}
                readOnly={readOnly}
                value={value}
                onChange={onChange}
                variant="inline"
                ampm={false}
                format="dd.MM.yyyy HH:mm"
                fullWidth
                invalidDateMessage=""
            />
        </MuiPickersUtilsProvider>
    )
};

MuiDatePicker.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    onChange: PropTypes.func,
    disabled: PropTypes.bool
}

export default MuiDatePicker;
